import React from 'react';
import { Stack, Box } from '@mui/material';
import { ConfigSwitchSection } from '../../../common';
import { AdditionalTransactionDataValue } from '../../../store/modules/merchant/types';

interface Props {
  isLoading?: boolean;
  disabled?: boolean;
  value?: AdditionalTransactionDataValue;
  onChange: (value: AdditionalTransactionDataValue) => void;
}

export const AdditionalTransactionData = ({
  isLoading = false,
  disabled = true,
  value,
  onChange,
}: Props) => {
  const levelTwo = value?.levelTwo ?? false;
  const levelThree = value?.levelThree ?? false;

  const handleLevelChange = (name: keyof AdditionalTransactionDataValue, next: boolean) => {
    onChange({
      levelTwo: name === 'levelTwo' ? next : levelTwo,
      levelThree: name === 'levelThree' ? next : levelThree,
    });
  };

  return (
    <Stack
      sx={{
        maxWidth: '450px',
        mt: 2,
      }}
    >
      <Box>
        <ConfigSwitchSection
          title="Additional Transaction Data"
          description="Enable Level 2 and Level 3 for submitting additional transaction data for payment processing. When a level is off, corresponding data for the level is not sent."
          isChecked={levelTwo}
          onToggle={(isChecked) => handleLevelChange('levelTwo', isChecked)}
          isLoading={isLoading}
          switchLabelTitle="Level 2 data"
          disabled={disabled}
        />
      </Box>
      <Box sx={{ mt: 2 }}>
        <ConfigSwitchSection
          isChecked={levelThree}
          onToggle={(isChecked) => handleLevelChange('levelThree', isChecked)}
          isLoading={isLoading}
          switchLabelTitle="Level 3 data"
          disabled={disabled}
        />
      </Box>
    </Stack>
  );
};
